import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './NoticeLists.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import URL from '../../../../constants/url';
import noDataImg from '../../../../images/common/i_3d_no_data_doc.svg';

import HeadSub from '../../../../components/comm/HeadSub';
import Skeleton from '@mui/material/Skeleton';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

const NoticeLists = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { hsptlCd = "" } = location.state || {};

    const [noticeList, setNoticeList] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const [searchInput, setSearchInput] = useState("");
    const [searchKeyword, setSearchKeyword] = useState("");

    const isSendingRef = useRef(false);
    const listRef = useRef(null);


    const hospitalinfo = {
        "012": { name: "서울성모병원" },
        "011": { name: "여의도성모병원" },
        "015": { name: "은평성모병원" },
        "013": { name: "의정부성모병원" },
        "014": { name: "부천성모병원" },
        "016": { name: "인천성모병원" },
        "018": { name: "대전성모병원" },
    };

    const hospital = hospitalinfo[hsptlCd] || { name: '' };

    useEffect(()=>{
        console.log("Kkkkkkkkk hospital : ", hospital)
    }, [])


    const PAGE_SIZE = 10;

    const getNotiInitInfo = useCallback(async (page, keyword = "") => {
        if (isSendingRef.current || !hasMore) return;
            isSendingRef.current = true;
            setIsLoading(true);

        try {
            const url = "/guide/board/retrieveBoardList";
            const notiInfoParam = {
                hsptlCd: hsptlCd,
                boardCd: "notice",
                pageNo: String(page),
                keyword: keyword,
            };

            const res = await axiosApi.post(url, notiInfoParam);

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const notiBundle = res.data.result.faqInfo;
                const parsed = JSON.parse(notiBundle);

                if (page === 1) {
                    setNoticeList(parsed);
                } else {
                    setNoticeList(prev => [...prev, ...parsed]);
                }

                if (parsed.length < PAGE_SIZE) {
                    setHasMore(false);
                } else {
                    setHasMore(true);
                }
            } else {
                setHasMore(false);
            }
        } catch (err) {
            console.error(err);
            setHasMore(false);
        } finally {
            setIsLoading(false);
            isSendingRef.current = false;
        }
    }, [hsptlCd, hasMore]);

    
    useEffect(() => {
        getNotiInitInfo(pageNo, searchKeyword);
    }, [pageNo, searchKeyword, getNotiInitInfo]);

    // 검색 실행 함수
    const handleSearch = () => {
        if (!searchInput.trim()) return;
        setPageNo(1);             // 1페이지부터 시작
        setNoticeList([]);        // 이전 리스트 초기화
        setHasMore(true);         // 더보기 가능성 리셋
        setSearchKeyword(searchInput.trim()); // keyword 업데이트
};

    
    const handleLoadMore = () => {
        if (!isLoading && hasMore) {
            setPageNo(prev => prev + 1);
        }
    };

    //뒤로가기 
    const handleBackClick = () => {
        navigate(URL.HOSPITAL_HOME, { replace: true });
    };



    return (
        <>
            <HeadSub title="공지사항" hospitalName={hospital.name} />

            <div id="sub-content" data-type="f">
                <div className='inner-wrap' data-padding="0">
                    <div className={style['search-wrap']}>
                        <div className={style['search-box']}>
                            <input 
                                type="text" 
                                value={searchInput}
                                placeholder="제목 또는 내용을 입력해주세요" 
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleSearch();
                                    }
                                }}
                            />
                            <button 
                                className={style['search-btn']} 
                                onClick={handleSearch}
                            ></button>
                        </div>
                    </div>

                    <div className='inner-wrap' data-pad="normal" style={{ paddingTop: 0, paddingBottom: 0 }}>
                        <div
                            className={`${style['notice-lists-box']} ${style['hide-scrollbar']}`}
                            ref={listRef}
                        >
                            <ul>
                                {isLoading && pageNo === 1 ? (
                                    Array.from({ length: 6 }).map((_, index) => (
                                        <li key={index}>
                                            <Skeleton variant="text" height={24} width={'80%'} />
                                            <p className={style['bot-box']}>
                                                <span><Skeleton variant="text" height={24} width={40} /></span>
                                                <span><Skeleton variant="text" height={24} width={40} /></span>
                                            </p>
                                        </li>
                                    ))
                                ) : noticeList.map((noti, index) => (
                                     <li
                                        key={index}
                                        onClick={() => {
                                            if (listRef.current) {
                                                sessionStorage.setItem('noticeScroll', listRef.current.scrollTop);
                                            }
                                            navigate(URL.HOSPITAL_NOTICEDETAIL, {
                                                state: {
                                                    hospCd: hsptlCd, 
                                                    notiTl: noti.title,
                                                    notiCnt: noti.readCnt,
                                                    notiCont: noti.content,
                                                    notiDate: noti.createdDt,
                                                    noticeList,
                                                    currentIndex: index,
                                                    initialPageNo: pageNo,   // 지금 페이지
                                                    isLastPage: !hasMore     // 마지막 페이지 여부도 같이 전달
                                                },
                                            });
                                        }}
                                    >
                                        {noti.noticeYn === "Y" && (
                                            <span className={style['mark']}>필독</span>
                                        )}
                                        <p className={style['title']}>{noti.title}</p>
                                        <p className={style['bot-box']}>
                                            <span>{(() => {
                                                const date = new Date(noti.createdDt);
                                                const yy = String(date.getFullYear()).slice(2); // 연도 뒤 2자리
                                                const mm = String(date.getMonth() + 1).padStart(2, '0');
                                                const dd = String(date.getDate()).padStart(2, '0');
                                                return `${yy}.${mm}.${dd}`;
                                            })()}</span> 
                                            <span>조회수 {Number(noti.readCnt).toLocaleString()}</span>
                                        </p>
                                    </li>
                                ))}
                            </ul>

                            {!isLoading && noticeList.length === 0 && (
                                <div className={style['no-result']}>
                                    <div className='animation-1'>
                                        <div className={style['img-box']}>
                                            <object data={noDataImg} aria-hidden='true'></object>        
                                        </div>
                                        <p>검색 결과가 없습니다.</p>
                                    </div>
                                </div>
                            )}

                            {/* 더보기 버튼 */}
                            {hasMore && !isLoading && (
                            <div className={style['more-btn-box']}>
                                <button
                                    className={style['more-btn']}
                                    onClick={handleLoadMore}
                                >
                                    <span>더 보기</span>
                                </button>
                            </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NoticeLists;
